import { InputLabel } from '../fields';

/**
 * A schema definition file to define the structure of the Ascend Quest Data Dictionary
 * payload
 */
export type HasExclusiveSubcodes = {
  exclusiveSubCodes?: string[];
};
export type AscendQuestDataDictionarySchemaForSubcode = {
  schema: AscendQuestDataDictionarySchema;
  subCode: string;
};

export interface ReportsAttributesType {
  attributes: AttributeGroup[];
}
export interface Reports {
  distribution: ReportsAttributesType;
}
export interface AscendQuestDataDictionarySchema {
  attributeGroups: AttributeGroup[];
  bundles: Bundle[];
  fullAttributes: FullAttribute[];
  config: Config[];
  demographics: Demographic[];
  inputLabels: InputLabel[];
  mandatoryOutputs: OutputField[];
  scores: Score[];
  reports: AttributeGroup[];
  trendviewFields: TrendviewField[];
  addonProducts: AddonProduct[];
  version: string;
}

export interface AttributeGroup extends HasExclusiveSubcodes {
  categories?: AttributeCategory[];
  description?: string;
  name: string;
}

export interface AttributeCategory extends HasExclusiveSubcodes {
  attributes?: Attribute[];
  description?: string;
  name: string;
}

export interface Attribute extends HasExclusiveSubcodes {
  code: string;
  description?: string;
  isActive: string;
  name?: string;
  outputFields: OutputField[];
}

export interface OutputField {
  defaultValues?: string;
  description?: string;
  displayGroupCode?: string;
  fieldLength: number;
  headerName: string;
  name: string;
  outputOrder: number;
  validValues?: string;
  source?: string;
  outputFile?: string;
}

export interface Bundle extends HasExclusiveSubcodes {
  name: string;
  code: string;
  description?: string;
  isActive: string;
  outputFields: OutputField[];
}

export interface FullAttribute {
  displayName: string;
  code: string;
  description?: string;
  attributeGroups: string[];
}

export interface Config {
  configRequired: string;
  defaultValues?: string;
  description?: string;
  fieldLength: number;
  fieldName: string;
  fieldType: string;
  outputRequired: string;
  validValues?: string;
}

export interface Demographic extends HasExclusiveSubcodes {
  name: string;
  code: string;
  description?: string;
  isActive: string;
  outputFields: OutputField[];
}
export interface Score extends HasExclusiveSubcodes {
  name: string;
  code: string;
  description?: string;
  isActive: string;
  outputFields: OutputField[];
}

export interface TrendviewField extends HasExclusiveSubcodes {
  name: string;
  code: string;
  description?: string;
  isActive: string;
  outputFields: OutputField[];
}

export interface Product extends HasExclusiveSubcodes {
  name: string;
  code: string;
  description?: string;
  isActive: string;
}

export interface AddonProduct extends HasExclusiveSubcodes {
  name: string;
  description?: string;
  products?: Product[];
}

export enum DataDictionaryDiffTypeEnum {
  ADD = 'Added',
  REMOVE = 'Removed',
  UPDATE = 'Updated',
}
export interface DataDictionaryDiff {
  path: string;
  type: DataDictionaryDiffTypeEnum;
  valueType: string;
  oldValue: Record<string, unknown>[];
  newValue: Record<string, unknown>[];
}
